import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SessionModule } from './session/session.module';
import { RippleModule} from 'primeng/ripple';
import {ToastModule} from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { CoreModule } from './core/core.module';
import { GlobalService } from './core/services/global.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SessionModule,
    RippleModule,
    ToastModule,
    CoreModule,
  ],
  providers: [
    MessageService,
    GlobalService,
  ],
  exports: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }